import React from "react"
import styled from "styled-components"
import _ from "lodash"

import automationService from "data/automation"
import ConfirmationModal from "components/modal/confirmation-modal"

type DeleteConfirmProps = {
  show: boolean
  close: Function
  confirm: Function
  rowNum: number
  unitDescription: string
  selected: object[]
  message?: string
  title?: string
}

const DeleteConfirmation = (props: DeleteConfirmProps) => {
  const isMultiselect = !_.isEmpty(props.selected)
  return (
    <ConfirmationModal
      height={isMultiselect ? undefined : 100}
      width={600}
      contentHeight={isMultiselect ? undefined : 50}
      show={props.show}
      toggleShow={props.close}
      title={(props.title || "Delete") + " Confirmation"}
      confirmText={props.title || "Delete"}
      message={""}
      confirmFunc={props.confirm}
      cancelFunc={props.close}
      confirmOnly={false}
      closeOnly={false}>
        {isMultiselect
          ? props.message || `Are you sure you want to delete ${props.selected.length} rows:`
          : `Are you sure you want to delete Row #: ${props.rowNum}, Unit: ${props.unitDescription}?`
        }
        {_.map(props.selected, (row) => <li>{row.unitdescription}</li>)}
    </ConfirmationModal>
  )
}

export default DeleteConfirmation
